import { SxProps, Theme } from '@mui/material/styles';
import { mergeSx } from '@/utils/cssStyles';

/**
 * The locked field is a filled grey box (Grey/200) with rounded corners and no border, per the
 * design system (Figma node 1240-78683) — not an outlined input with a dimmed value.
 */
const baseLockedSx: SxProps<Theme> = (theme) => ({
  background: theme.palette.background.neutral,
  borderRadius: `${theme.shape.borderRadius}px`,
  opacity: 1,
  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
  '.Mui-disabled.MuiInputBase-input': {
    WebkitTextFillColor: theme.palette.text.primary,
  },
  '.MuiInputLabel-root.Mui-disabled': {
    bgcolor: theme.palette.background.neutral,
    px: 0.5,
    borderRadius: 0.5,
    color: theme.palette.text.secondary,
  },
});

export const lockedTextFieldSx: SxProps<Theme> = mergeSx(baseLockedSx, { input: { cursor: 'not-allowed' } });

/**
 * Select-flavoured variant of {@link lockedTextFieldSx}. A MUI Select renders its value in a
 * `.MuiSelect-select` element rather than a plain `input`, so the not-allowed cursor is applied
 * there instead.
 */
export const lockedSelectFieldSx: SxProps<Theme> = mergeSx(baseLockedSx, {
  '.MuiSelect-select': { cursor: 'not-allowed' },
});
